import { render, staticRenderFns } from "./CompleteNewPassword.vue?vue&type=template&id=778ee840&scoped=true"
import script from "./CompleteNewPassword.vue?vue&type=script&lang=js"
export * from "./CompleteNewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778ee840",
  null
  
)

export default component.exports